import type { FieldPolicy } from "@apollo/client";
import { Temporal } from "temporal-polyfill";

export const dateTypePolicy: FieldPolicy<Temporal.PlainDate, string | Date | Temporal.PlainDate, string> = {
  merge: (_, incoming) => {
    if (incoming == null) return incoming;
    return toPlainDate(incoming);
  },
};

export const dateTimeTypePolicy: FieldPolicy<Temporal.ZonedDateTime, string | Date | Temporal.ZonedDateTime, string> = {
  merge: (_, incoming) => {
    if (incoming == null) return incoming;
    return toZonedDateTime(incoming);
  },
};

/** Used for custom query resolvers that return a list of dates */
export const dateArrayTypePolicy: FieldPolicy<
  Array<Temporal.PlainDate>,
  Array<string | Date | Temporal.PlainDate>,
  string
> = {
  merge: (_, incoming) => {
    if (incoming == null) return incoming;
    return incoming.map((date) => toPlainDate(date));
  },
};

function toPlainDate(date: Date | string | Temporal.PlainDate): Temporal.PlainDate {
  if (date instanceof Temporal.PlainDate) {
    return date;
  } else if (date instanceof Date) {
    return Temporal.PlainDate.from({ year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() });
  } else {
    return Temporal.PlainDate.from(date);
  }
}

function toZonedDateTime(date: Date | string | Temporal.ZonedDateTime): Temporal.ZonedDateTime {
  if (date instanceof Temporal.ZonedDateTime) {
    return date;
  } else if (date instanceof Date) {
    return Temporal.Instant.fromEpochMilliseconds(date.getTime()).toZonedDateTimeISO("UTC");
  } else {
    return Temporal.Instant.from(date).toZonedDateTimeISO("UTC");
  }
}
